import { render, staticRenderFns } from "./StockUsedLabel.vue?vue&type=template&id=d61deb6c&scoped=true&"
import script from "./StockUsedLabel.vue?vue&type=script&lang=js&"
export * from "./StockUsedLabel.vue?vue&type=script&lang=js&"
import style0 from "./StockUsedLabel.vue?vue&type=style&index=0&id=d61deb6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61deb6c",
  null
  
)

export default component.exports